//判断是否为企业微信
export function isEnterpriseWeChat(){
    let ua = navigator.userAgent.toLowerCase();
    if(/wxwork/.test(ua) ? true : false){
        return true
    }else {
        return false
    }
}
